import bigcityLogo from './picture/bigcity-logo.svg'
import facebook from './icons/facebook.svg'
import twitter from './icons/Twitter.svg'
import linkedin from './icons/Linkedin.svg'
import search from './icons/search.svg'
import closeIcon from './icons/close.svg';
import otp from './icons/otp.svg';
import accunt from './icons/account.svg';
import congrat from './icons/congratulation.svg';
import plus from './icons/plus.svg'
import xmark from './icons/xmark.svg';
import phoneCall from './icons/phone-call.svg';
import mail from './icons/email.svg';
import location from './icons/location-filled.svg';
import insta from './icons/insta.svg';
import twit from './icons/twitter-blue.svg';
import game from './icons/game.svg';
import RadioSelected from './picture/Radio-selected.svg';
import Radio from './picture/readio.svg'
import Loader from './picture/loader.webp'
import noDataFound from './picture/noDataFound.svg'
import logo from './picture/logo-sinuppage.png'
import userimage from './picture/userImage.png'
import finalLogo from './picture/logo-sinuppage.png'
import healthCoaching from './picture/healthCoachin.svg'
import healthAssesment from './picture/healthAssesment.svg'
import nutritionCounselling from './picture/nutritionCounselling.svg'
import fitnessProgram from './picture/fitnessProgram.svg'
import mentalHealthSupport from './picture/mentalSupportHealth.svg'
import stressManagement from './picture/stresManagement.svg'
import loginLogo from './picture/Login-Logo.svg'
import healthians from './picture/healthians.svg'
import apolloPharmacy from './picture/apolloPharmacy.svg'
import netmeds from './picture/netmeds.svg'
import qua from './picture/qua.svg'
import apollo from './picture/apollo.svg'
import kapiva from './picture/kapiva.svg'
import healthBannerOne from './picture/healthBannerOne.png'
import healthBannerTwo from './picture/healthBannerTwoo.png'
import healthBannerThree from './picture/healthBannerThree.png'
import healthBannerFour from './picture/healthBannerFour.png'
import healthBannerFive from './picture/healthBannerFive.png'
import healthBannerSix from './picture/healthBannerSix.png'

export const IMAGES = {
    bigcityLogo: bigcityLogo,
    twitter: twitter,
    linkedin: linkedin,
    facebook: facebook,
    search: search,
    closeIcon: closeIcon,
    otp: otp,
    accunt: accunt,
    congrat: congrat,
    plus: plus,
    xmark: xmark,
    phoneCall: phoneCall,
    mail: mail,
    game: game,
    locaiton: location,
    twit: twit,
    insta: insta,
    RadioSelected: RadioSelected,
    Radio: Radio,
    Loader: Loader,
    noDataFound: noDataFound,
    logo: logo,
    finalLogo: finalLogo,
    userimage: userimage,


    healthBannerOne: healthBannerOne,
    healthBannerTwo: healthBannerTwo,
    healthBannerThree: healthBannerThree,
    healthBannerFour: healthBannerFour,
    healthBannerFive: healthBannerFive,
    healthBannerSix: healthBannerSix,

    healthCoaching: healthCoaching,
    healthAssesment: healthAssesment,
    nutritionCounselling: nutritionCounselling,
    fitnessProgram: fitnessProgram,
    mentalHealthSupport: mentalHealthSupport,
    stressManagement: stressManagement,

    loginLogo: loginLogo,
    healthians: healthians,
    apolloPharmacy: apolloPharmacy,
    netmeds: netmeds,
    qua: qua,
    apollo: apollo,
    kapiva: kapiva,
};
